export default __webpack_public_path__ + "static/media/standsExpo_casa segura.b2cbecf0.jpg";